var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('produit_show',{attrs:{"id":_vm.$route.params.product_id}})}
var staticRenderFns = []

export { render, staticRenderFns }